import React, {useState} from "react";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import Dropdown from "react-dropdown";
import { API } from "../../api-service";
import {nursestatuses} from "../statuses";

export default function Feedback(props){
    const [status, setStatus] = useState(null);
    const [message, setMessage] = useState("");

    const confirmClicked = () => {
        if(status){
            let newCase = props.cases[props.caseIndex];
            newCase.feedback_status = status;
            newCase.feedback_message = message;
            props.setCases(prev => {return [...prev.slice(0, props.caseIndex),
                                            newCase, 
                                            ...prev.slice(props.caseIndex+1)
            ]});
            API.updateCase(props.cases[props.caseIndex].case_reference_no, newCase, props.token['pn-token']);
            setStatus(null);
            setMessage("");
            props.onHide();
            alert("Feedback Uploaded.");
        }
        else{
            alert("Please select a status.");
        }
        
    }

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <Modal.Title id="contained-modal-title-vcenter">
                    Case {props.cases[props.caseIndex].case_reference_no} 
                    
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 10fr 5fr",
                gridGap: "20px",
            }}>
                <span/>
                <p style={{marginTop:'5px'}}>Status:</p>
                <Dropdown onChange={evt => setStatus(evt.value)} options={nursestatuses} placeholder="Select Status"/>
                <span/>
                <span/>
                <p style={{marginTop:'30px'}}>Feedback:</p>
                <textarea style={{height:'100px', paddingLeft:'5px', paddingTop:'2px'}}onChange={(text) => setMessage(text.target.value)} value={message} placeholder="Feedback Message"/>
                <span/>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => confirmClicked()}>Confirm</Button>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}